import { ShipmentDirection, ShipmentStatus } from '../../../../@posturinn/client-react';
import { ReactComponent as IconCar } from '../../../../icons/car.svg';
import { ReactComponent as IconHandBox } from '../../../../icons/hand-box.svg';
import { ReactComponent as IconHouse } from '../../../../icons/house.svg';
import { ReactComponent as IconParcel } from '../../../../icons/parcel.svg';
import { ReactComponent as IconPlane } from '../../../../icons/plane.svg';
import { ReactComponent as IconPostbox } from '../../../../icons/postbox.svg';
import { ReactComponent as IconPostoffice } from '../../../../icons/postoffice.svg';
import { ReactComponent as IconShop } from '../../../../icons/shop.svg';
import ITrackShipmentResults from '../../../../interfaces/trackShipment/trackShipmentResults';
import { IIconArrowStep } from '../../../iconArrowSteps/iconArrowSteps';

export const getIconArrowSteps = (
	t: any = null,
	internationalShipment: boolean = false,
	shipmentInfo: ITrackShipmentResults
): IIconArrowStep[] => {
	let IconForDelivery;
	let finalStepText = 'delivered';
	// TODO
	switch (shipmentInfo.mailType) {
		case 'DPO':
			IconForDelivery = IconPostbox;
			break;
		case 'DPH':
			IconForDelivery = IconCar;
			break;
		case 'DPP':
			IconForDelivery = IconPostoffice;
			break;
		default:
			IconForDelivery = IconHouse;
	}

	if (shipmentInfo.shipmentStatus === ShipmentStatus.ReturnedToSender) {
		finalStepText = 'returned';
	}

	if (internationalShipment) {
		let steps: IIconArrowStep[] = [];
		// Is inbound
		if (!shipmentInfo.isDomestic && shipmentInfo.direction === ShipmentDirection.Inbound) {
			steps = [
				{
					iconComponent: IconParcel,
					primary: false,
					secondary: false,
					text: t ? t('in-origin-country') : '',
				},
				{
					iconComponent: IconPlane,
					primary: false,
					secondary: false,
					text: t ? t('arrived-to-iceland') : '',
				},
				{
					iconComponent: IconHouse,
					primary: false,
					secondary: false,
					text: t ? t('in-customs') : '',
				},
				{
					iconComponent: IconCar,
					primary: false,
					secondary: false,
					text: t ? t('shipment-in-transit') : '',
				},
				{
					iconComponent: IconForDelivery,
					primary: false,
					secondary: false,
					text: t ? t('ready-for-delivery') : '',
				},
				{
					iconComponent: IconHandBox,
					primary: false,
					secondary: false,
					text: t ? t(finalStepText) : '',
				},
			];
		} else {
			// Outbound international shipment
			steps = [
				{
					iconComponent: IconParcel,
					primary: false,
					secondary: false,
					text: t ? t('in-iceland') : '',
				},
				{
					iconComponent: IconPlane,
					primary: false,
					secondary: false,
					text: t ? t('left-the-country') : '',
				},
				{
					iconComponent: IconHouse,
					primary: false,
					secondary: false,
					text: t ? t('in-customs') : '',
				},
				{
					iconComponent: IconCar,
					primary: false,
					secondary: false,
					text: t ? t('shipment-in-transit') : '',
				},
				{
					iconComponent: IconForDelivery,
					primary: false,
					secondary: false,
					text: t ? t('ready-for-delivery') : '',
				},
				{
					iconComponent: IconHandBox,
					primary: false,
					secondary: false,
					text: t ? t(finalStepText) : '',
				},
			];
		}
		return steps;
	}

	const steps: IIconArrowStep[] = [
		{
			iconComponent: IconParcel,
			primary: false,
			secondary: false,
			text: t ? t('shipment-registered') : '',
		},
		{
			iconComponent: IconShop,
			primary: false,
			secondary: false,
			text: t ? t('shipment-received') : '',
		},
		{
			iconComponent: IconCar,
			primary: false,
			secondary: false,
			text: t ? t('shipment-in-transit') : '',
		},
		{
			iconComponent: IconForDelivery,
			primary: false,
			secondary: false,
			text: t ? t('ready-for-delivery') : '',
		},
		{
			iconComponent: IconHandBox,
			primary: false,
			secondary: false,
			text: t ? t(finalStepText) : '',
		},
	];
	return steps;
};
